module.exports = __webpack_public_path__ + "img/2U.82cf5fd9.jpg";